// src/components/Home.js
import React from "react";
import main from "../../../assets/ft-doc.webp";
import { Grid2, Box } from "@mui/material";
import reminder_ic from "../../../assets/carbon_reminder.png";
import deadline_ic from "../../../assets/deadline-sort.svg";
import track_ic from "../../../assets/track-changes.svg";
import assign_ic from "../../../assets/assignment-add-outline.svg";
import { blue, amber } from "@mui/material/colors";

const DocumentItem = () => {
    const features = [
        {
            icon: assign_ic,
            title: "Cloud Storage",
            description:
                "Store and manage your project files easily with our intergrated cloud storage",
            color: blue[700],
        },
        {
            icon: track_ic,
            title: "Version Control",
            description:
                "Easily track changes made to documents easily",
            color: amber[600],
        },
        {
            icon: deadline_ic,
            title: "Document Sharing",
            description:
                "Easily share documents with team members",
            color: amber[600],
        },
        {
            icon: reminder_ic,
            title: "Advanced Search and Filters",
            description:
                "Find documents instantly with smart search capability",
            color: blue[700],
        },
    ];

    return <section id="features">
        <div className="container-top-2">
            <h1 className="h1-48-600">
                <span>Document </span>
                Management.
            </h1>
            <p className="ft-para">
                Securely store and manage your project files in one place, enabling easy access
                for authorized users and efficient document collaboration.
            </p>
            {/* <button className="outlined-button-type2"
                type='button'
                onClick={(e) => { }}>
                Request Demo
            </button> */}
        </div>

        <div className="container-ft-images">
            <div className="main-image-wrapper">
                <img
                    src={main}
                    alt="Main"
                    className="main-image"
                />
                {/* <img
                    src={secondary}
                    alt="Small"
                    className="small-image"
                /> */}
            </div>
        </div>

        <div className="container-top">
            <h1 className="h1-48-600">
                Key <span>Benefits</span>
            </h1>
            <p className="ft-para">
                Why choose our document management feature? Store and manage your project documents efficiently
            </p>
        </div>
        <div className="grid-container">
            <Grid2 container rowSpacing={2} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                {features.map((feature, index) => (
                    <Grid2 key={index} size={{ xs: 12, sm: 12, md: 6 }} className="grid-item">
                        <div className="feature-item">
                            <div className="feature-top">
                                <Box
                                    sx={{
                                        width: { xs: 24, sm: 30, md: 48, lg: 52 },
                                        height: { xs: 24, sm: 30, md: 48, lg: 52 },
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        padding: "8px",
                                        bgcolor: feature.color,
                                        marginRight: "20px",
                                        borderRadius: "20px",
                                    }}
                                >
                                    <img
                                        src={feature.icon}
                                        alt="Feature icon"
                                        style={{
                                            maxWidth: "100%",
                                            maxHeight: "100%",
                                            objectFit: "contain",
                                        }} />
                                </Box>
                                <p className="feature-item-title">
                                    {feature.title}
                                </p>
                            </div>
                            <div className="feature-content">
                                <p className="feature-item-text">
                                    {feature.description}
                                </p>
                            </div>
                        </div>
                    </Grid2>
                ))}
            </Grid2>
        </div>
    </section >;
};
export default DocumentItem;
